module.exports = __webpack_public_path__ + "img/homeSec03bg8.529b7aa7.jpg";